
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as Li93YXNtL21hZ2VzX2ZmaS5qcw from './wasm/mages_ffi.js';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as cGFrbw from 'pako';
import * as d2FzbTpqcy1zdHJpbmc from './mages.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li93YXNtL21hZ2VzX2ZmaS5qcw_ = Li93YXNtL21hZ2VzX2ZmaS5qcw;
const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_cGFrbw_ = cGFrbw;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.Promise_$external_fun' : (p0) => new Promise(p0),
    'kotlin.js.__callJsClosure_((Js?)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__callJsClosure_((Js)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_2' : (f, trampoline) => getCachedJsObject(f, (p0, p1) => trampoline(f, p0, p1)),
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.promiseSetDeferred' : (promise, deferred) => promise.deferred = deferred,
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.stopPropagation_$external_fun' : (_this, ) => _this.stopPropagation(),
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.close_$external_fun' : (_this, ) => _this.close(),
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
    'org.w3c.dom.Worker_$external_class_get' : () => Worker,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.baseURI_$external_prop_getter' : (_this) => _this.baseURI,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.ownerDocument_$external_prop_getter' : (_this) => _this.ownerDocument,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.StorageEvent_$external_class_instanceof' : (x) => x instanceof StorageEvent,
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.Storage_$external_class_instanceof' : (x) => x instanceof Storage,
    'org.w3c.dom.Storage_$external_class_get' : () => Storage,
    'org.w3c.dom.target_$external_prop_setter' : (_this, v) => _this.target = v,
    'org.w3c.dom.download_$external_prop_setter' : (_this, v) => _this.download = v,
    'org.w3c.dom.rel_$external_prop_setter' : (_this, v) => _this.rel = v,
    'org.w3c.dom.HTMLAnchorElement_$external_class_instanceof' : (x) => x instanceof HTMLAnchorElement,
    'org.w3c.dom.HTMLAnchorElement_$external_class_get' : () => HTMLAnchorElement,
    'org.w3c.dom.accept_$external_prop_setter' : (_this, v) => _this.accept = v,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
    'org.w3c.dom.HTMLAudioElement_$external_class_instanceof' : (x) => x instanceof HTMLAudioElement,
    'org.w3c.dom.HTMLAudioElement_$external_class_get' : () => HTMLAudioElement,
    'org.w3c.dom.src_$external_prop_setter' : (_this, v) => _this.src = v,
    'org.w3c.dom.currentTime_$external_prop_getter' : (_this) => _this.currentTime,
    'org.w3c.dom.currentTime_$external_prop_setter' : (_this, v) => _this.currentTime = v,
    'org.w3c.dom.duration_$external_prop_getter' : (_this) => _this.duration,
    'org.w3c.dom.playbackRate_$external_prop_setter' : (_this, v) => _this.playbackRate = v,
    'org.w3c.dom.volume_$external_prop_setter' : (_this, v) => _this.volume = v,
    'org.w3c.dom.play_$external_fun' : (_this, ) => _this.play(),
    'org.w3c.dom.pause_$external_fun' : (_this, ) => _this.pause(),
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.url.URL_$external_fun' : (p0, p1, isDefault0) => new URL(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.url.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.url.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.files.size_$external_prop_getter' : (_this) => _this.size,
    'org.w3c.files.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.files.File_$external_fun' : (p0, p1, p2, isDefault0) => new File(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.files.File_$external_class_instanceof' : (x) => x instanceof File,
    'org.w3c.files.File_$external_class_get' : () => File,
    'org.w3c.files.FileReader_$external_fun' : () => new FileReader(),
    'org.w3c.files.result_$external_prop_getter' : (_this) => _this.result,
    'org.w3c.files.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
    'org.w3c.files.readAsArrayBuffer_$external_fun' : (_this, p0) => _this.readAsArrayBuffer(p0),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.sessionStorage_$external_prop_getter' : () => sessionStorage,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skia.webext.skikoArrayBuffer' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'org.jetbrains.skia.webext.copyBuffer' : (src, dst, dstOffset) => { 
            var dstView = new Uint8Array(dst);
            var srcView = new Uint8Array(src);
            dstView.set(srcView, dstOffset);
         },
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.isWasmExportsAvailable' : () => typeof wasmExports !== 'undefined',
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
               return new Intl.Locale(locale).weekInfo.firstDay; 
            } catch (error) { 
               return -1; 
          }},
    'androidx.compose.material3.internal.getIs24HourFormat' : (localeTag) => {
                var locale = new Intl.Locale(localeTag);
                // Check for the hourCycles property first
                if (locale.hourCycles) {
                    return locale.hourCycles.includes('h23') || locale.hourCycles.includes('h24') ? 1 : 0;
                }

                // Fallback to hourCycle property
                if (locale.hourCycle) {
                    return locale.hourCycle === 'h23' || locale.hourCycle === 'h24' ? 1 : 0;
                }
                return -1;
            },
    'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
    'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
    'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
    'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
    'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
    'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
    'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
    'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
    'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
    'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
    'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
    'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
    'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
    'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
    'androidx.compose.material3.internal.Date_$external_class_instanceof' : (x) => x instanceof Date,
    'androidx.compose.material3.internal.Date_$external_class_get' : () => Date,
    'androidx.datastore.core.okio.getArrayBufferFromBlob' : (blob) => blob.arrayBuffer(),
    'androidx.datastore.core.okio.getInt8' : (array, index) => array[index],
    'androidx.datastore.core.okio.setInt8' : (array, index, value) => array[index] = value,
    'androidx.datastore.core.okio.getWasmOpfsRoot' : () => window.navigator.storage.getDirectory(),
    'androidx.datastore.core.okio.getWasmNavigator' : () => navigator,
    'androidx.datastore.core.okio.createWritable_$external_fun' : (_this, ) => _this.createWritable(),
    'androidx.datastore.core.okio.getFile_$external_fun' : (_this, ) => _this.getFile(),
    'androidx.datastore.core.okio.getFileHandle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getFileHandle(p0, isDefault0 ? undefined : p1, ),
    'androidx.datastore.core.okio.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.datastore.core.okio.close_$external_fun' : (_this, ) => _this.close(),
    'androidx.datastore.core.okio.request_$external_fun' : (_this, p0, p1) => _this.request(p0, p1),
    'androidx.datastore.core.okio.request_$external_fun_1' : (_this, p0, p1, p2) => _this.request(p0, p1, p2),
    'androidx.datastore.core.okio.locks_$external_prop_getter' : (_this) => _this.locks,
    'androidx.datastore.core.okio.createCreateOptions' : () => ({create: true}),
    'androidx.datastore.core.okio.BroadcastChannel_$external_fun' : (p0) => new BroadcastChannel(p0),
    'androidx.datastore.core.okio.postMessage_$external_fun' : (_this, p0) => _this.postMessage(p0),
    'androidx.datastore.core.okio.close_$external_fun_1' : (_this, ) => _this.close(),
    'androidx.datastore.core.okio.onmessage_$external_prop_setter' : (_this, v) => _this.onmessage = v,
    'androidx.datastore.core.okio.tryLockOptions' : () => ({mode: 'exclusive', ifAvailable: true}),
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'dev.jordond.compass.geolocation.browser.api.model.latitude_$external_prop_getter' : (_this) => _this.latitude,
    'dev.jordond.compass.geolocation.browser.api.model.longitude_$external_prop_getter' : (_this) => _this.longitude,
    'dev.jordond.compass.geolocation.browser.api.model.accuracy_$external_prop_getter' : (_this) => _this.accuracy,
    'dev.jordond.compass.geolocation.browser.api.model.altitude_$external_prop_getter' : (_this) => _this.altitude,
    'dev.jordond.compass.geolocation.browser.api.model.altitudeAccuracy_$external_prop_getter' : (_this) => _this.altitudeAccuracy,
    'dev.jordond.compass.geolocation.browser.api.model.heading_$external_prop_getter' : (_this) => _this.heading,
    'dev.jordond.compass.geolocation.browser.api.model.speed_$external_prop_getter' : (_this) => _this.speed,
    'dev.jordond.compass.geolocation.browser.api.model.coords_$external_prop_getter' : (_this) => _this.coords,
    'dev.jordond.compass.geolocation.browser.api.model.timestamp_$external_prop_getter' : (_this) => _this.timestamp,
    'dev.jordond.compass.geolocation.browser.api.model.code_$external_prop_getter' : (_this) => _this.code,
    'dev.jordond.compass.geolocation.browser.api.model.message_$external_prop_getter' : (_this) => _this.message,
    'dev.jordond.compass.geolocation.browser.api.getCurrentPosition_$external_fun' : (_this, p0, p1, p2) => _this.getCurrentPosition(p0, p1, p2),
    'dev.jordond.compass.geolocation.browser.api.watchPosition_$external_fun' : (_this, p0, p1, p2) => _this.watchPosition(p0, p1, p2),
    'dev.jordond.compass.geolocation.browser.api.clearWatch_$external_fun' : (_this, p0) => _this.clearWatch(p0),
    'dev.jordond.compass.geolocation.browser.api.geolocation_$external_prop_getter' : (_this) => _this.geolocation,
    'dev.jordond.compass.geolocation.browser.api.navigator_$external_prop_getter' : () => navigator,
    'dev.jordond.compass.geolocation.browser.api.model.createGeolocationOptions' : (enableHighAccuracy, timeout, maximumAge) => ({enableHighAccuracy: enableHighAccuracy, timeout: timeout, maximumAge: maximumAge}),
    'org.intellij.markdown.html.urlEncode_$external_fun' : (p0) => encodeURIComponent(p0),
    'org.intellij.markdown.html.createURL_$external_fun' : (p0, p1, isDefault0) => (
        function createURL(str, base) {
           try {
             return new URL(str, base);
           } catch(e) {
             return null;
           }
        }
    )(p0, isDefault0 ? undefined : p1, ),
    'coil3.decode.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'coil3.decode.WebWorkerRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
    'coil3.decode.id_$external_prop_getter' : (_this) => _this.id,
    'coil3.decode.kind_$external_prop_getter' : (_this) => _this.kind,
    'coil3.decode.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'coil3.decode.message_$external_prop_getter' : (_this) => _this.message,
    'coil3.fetch.fetch' : (url) => fetch(url),
    'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
    'io.github.vinceglb.filekit.name_$external_prop_getter' : (_this) => _this.name,
    'io.github.vinceglb.filekit.webkitRelativePath_$external_prop_getter' : (_this) => _this.webkitRelativePath,
    'io.github.vinceglb.filekit.dialogs.accept_$external_prop_setter' : (_this, v) => _this.accept = v,
    'io.github.vinceglb.filekit.dialogs.files_$external_prop_getter' : (_this) => _this.files,
    'io.github.vinceglb.filekit.dialogs.multiple_$external_prop_setter' : (_this, v) => _this.multiple = v,
    'io.github.vinceglb.filekit.dialogs.webkitdirectory_$external_prop_setter' : (_this, v) => _this.webkitdirectory = v,
    'io.github.vinceglb.filekit.dialogs.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'io.github.vinceglb.filekit.dialogs.onchange_$external_prop_setter' : (_this, v) => _this.onchange = v,
    'io.github.vinceglb.filekit.dialogs.oncancel_$external_prop_setter' : (_this, v) => _this.oncancel = v,
    'io.github.vinceglb.filekit.dialogs.click_$external_fun' : (_this, ) => _this.click(),
    'no.synth.kmpzip.zip.latin1StringToUint8Array' : (s, length) => (() => { const arr = new Uint8Array(length); for (let i = 0; i < length; i++) arr[i] = s.charCodeAt(i); return arr; })(),
    'no.synth.kmpzip.zip.uint8ArrayToLatin1String' : (arr, start, length) => (() => {
            const slice = arr.subarray(start, start + length);
            const CHUNK = 16384;
            let result = '';
            for (let i = 0; i < slice.length; i += CHUNK) {
                result += String.fromCharCode.apply(null, slice.subarray(i, i + CHUNK));
            }
            return result;
        })(),
    'no.synth.kmpzip.internal.Uint8Array_$external_fun' : (p0) => new Uint8Array(p0),
    'no.synth.kmpzip.internal.length_$external_prop_getter' : (_this) => _this.length,
    'no.synth.kmpzip.zip.Inflate_$external_fun' : (p0) => new _ref_cGFrbw_.Inflate(p0),
    'no.synth.kmpzip.zip.err_$external_prop_getter' : (_this) => _this.err,
    'no.synth.kmpzip.zip.msg_$external_prop_getter' : (_this) => _this.msg,
    'no.synth.kmpzip.zip.ended_$external_prop_getter' : (_this) => _this.ended,
    'no.synth.kmpzip.zip.chunks_$external_prop_getter' : (_this) => _this.chunks,
    'no.synth.kmpzip.zip.result_$external_prop_getter' : (_this) => _this.result,
    'no.synth.kmpzip.zip.strm_$external_prop_getter' : (_this) => _this.strm,
    'no.synth.kmpzip.zip.push_$external_fun' : (_this, p0, p1) => _this.push(p0, p1),
    'no.synth.kmpzip.zip.pakoInflateOptions' : (raw, gzip, chunkSize) => ({ raw: raw, windowBits: gzip ? 31 : 15, chunkSize: chunkSize }),
    'no.synth.kmpzip.zip.strmAvailIn' : (strm) => strm.avail_in,
    'no.synth.kmpzip.zip.chunksHead' : (chunks) => chunks[0],
    'no.synth.kmpzip.zip.chunksShift' : (chunks) => chunks.shift(),
    'no.synth.kmpzip.zip.chunksTrimHead' : (chunks, prefix) => chunks[0] = chunks[0].subarray(prefix),
    'no.synth.kmpzip.zip.chunksLength' : (chunks) => chunks.length,
    'io.github.alexzhirkevich.compottie.internal.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'io.github.alexzhirkevich.compottie.internal.id_$external_prop_getter' : (_this) => _this.id,
    'io.github.alexzhirkevich.compottie.internal.kind_$external_prop_getter' : (_this) => _this.kind,
    'io.github.alexzhirkevich.compottie.internal.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'io.github.alexzhirkevich.compottie.internal.id_$external_prop_getter_1' : (_this) => _this.id,
    'io.github.alexzhirkevich.compottie.internal.message_$external_prop_getter' : (_this) => _this.message,
    'io.github.alexzhirkevich.compottie.internal.platform.DecodeImageRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'org.mlm.mages.matrix.createAsync_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1, isDefault2) => _this.createAsync(p0, p1, isDefault0 ? undefined : p2, isDefault1 ? undefined : p3, isDefault2 ? undefined : p4, ),
    'org.mlm.mages.matrix.Companion_$external_object_getInstance' : () => _ref_Li93YXNtL21hZ2VzX2ZmaS5qcw_.WasmClient,
    'org.mlm.mages.matrix.free_$external_fun' : (_this, ) => _this.free(),
    'org.mlm.mages.matrix.acceptAndObserveVerification_$external_fun' : (_this, p0, p1, p2) => _this.acceptAndObserveVerification(p0, p1, p2),
    'org.mlm.mages.matrix.acceptInvite_$external_fun' : (_this, p0) => _this.acceptInvite(p0),
    'org.mlm.mages.matrix.accountData_$external_fun' : (_this, p0) => _this.accountData(p0),
    'org.mlm.mages.matrix.accountManagementUrl_$external_fun' : (_this, ) => _this.accountManagementUrl(),
    'org.mlm.mages.matrix.addNotificationKeyword_$external_fun' : (_this, p0) => _this.addNotificationKeyword(p0),
    'org.mlm.mages.matrix.allUsersVerified_$external_fun' : (_this, p0) => _this.allUsersVerified(p0),
    'org.mlm.mages.matrix.applyPowerLevelChanges_$external_fun' : (_this, p0, p1) => _this.applyPowerLevelChanges(p0, p1),
    'org.mlm.mages.matrix.applySyncPresence_$external_fun' : (_this, p0) => _this.applySyncPresence(p0),
    'org.mlm.mages.matrix.backupExistsOnServer_$external_fun' : (_this, p0) => _this.backupExistsOnServer(p0),
    'org.mlm.mages.matrix.banUser_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.banUser(p0, p1, isDefault0 ? undefined : p2, ),
    'org.mlm.mages.matrix.callWidgetFromWebview_$external_fun' : (_this, p0, p1) => _this.callWidgetFromWebview(p0, p1),
    'org.mlm.mages.matrix.canEditImagePacks_$external_fun' : (_this, p0) => _this.canEditImagePacks(p0),
    'org.mlm.mages.matrix.canSetProfileFields_$external_fun' : (_this, ) => _this.canSetProfileFields(),
    'org.mlm.mages.matrix.cancelVerificationWithUser_$external_fun' : (_this, p0, p1) => _this.cancelVerificationWithUser(p0, p1),
    'org.mlm.mages.matrix.cancelVerification_$external_fun' : (_this, p0) => _this.cancelVerification(p0),
    'org.mlm.mages.matrix.clearMediaAboveSize_$external_fun' : (_this, p0) => _this.clearMediaAboveSize(p0),
    'org.mlm.mages.matrix.clearMediaCacheOlderThan_$external_fun' : (_this, p0) => _this.clearMediaCacheOlderThan(p0),
    'org.mlm.mages.matrix.clearMediaCache_$external_fun' : (_this, ) => _this.clearMediaCache(),
    'org.mlm.mages.matrix.clearMediaItems_$external_fun' : (_this, p0) => _this.clearMediaItems(p0),
    'org.mlm.mages.matrix.clearMediaType_$external_fun' : (_this, p0) => _this.clearMediaType(p0),
    'org.mlm.mages.matrix.clearRoomMedia_$external_fun' : (_this, p0) => _this.clearRoomMedia(p0),
    'org.mlm.mages.matrix.confirmSasWithUser_$external_fun' : (_this, p0, p1) => _this.confirmSasWithUser(p0, p1),
    'org.mlm.mages.matrix.confirmSas_$external_fun' : (_this, p0) => _this.confirmSas(p0),
    'org.mlm.mages.matrix.createRoom_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0) => _this.createRoom(p0, p1, p2, p3, isDefault0 ? undefined : p4, ),
    'org.mlm.mages.matrix.createSection_$external_fun' : (_this, p0, p1) => _this.createSection(p0, p1),
    'org.mlm.mages.matrix.createSpace_$external_fun' : (_this, p0, p1, p2, p3) => _this.createSpace(p0, p1, p2, p3),
    'org.mlm.mages.matrix.declineCall_$external_fun' : (_this, p0, p1) => _this.declineCall(p0, p1),
    'org.mlm.mages.matrix.deleteProfileField_$external_fun' : (_this, p0) => _this.deleteProfileField(p0),
    'org.mlm.mages.matrix.deleteSection_$external_fun' : (_this, p0) => _this.deleteSection(p0),
    'org.mlm.mages.matrix.dmPeerUserId_$external_fun' : (_this, p0) => _this.dmPeerUserId(p0),
    'org.mlm.mages.matrix.downloadAttachmentToCacheFile_$external_fun' : (_this, p0, p1, isDefault0) => _this.downloadAttachmentToCacheFile(p0, isDefault0 ? undefined : p1, ),
    'org.mlm.mages.matrix.editCaption_$external_fun' : (_this, p0, p1, p2, p3, isDefault0, isDefault1) => _this.editCaption(p0, p1, isDefault0 ? undefined : p2, isDefault1 ? undefined : p3, ),
    'org.mlm.mages.matrix.editPoll_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.editPoll(p0, p1, p2, p3, p4, p5),
    'org.mlm.mages.matrix.edit_$external_fun' : (_this, p0, p1, p2, p3, isDefault0) => _this.edit(p0, p1, p2, isDefault0 ? undefined : p3, ),
    'org.mlm.mages.matrix.enableRoomEncryption_$external_fun' : (_this, p0) => _this.enableRoomEncryption(p0),
    'org.mlm.mages.matrix.ensureDmIfAllowed_$external_fun' : (_this, p0, p1) => _this.ensureDmIfAllowed(p0, p1),
    'org.mlm.mages.matrix.ensureDm_$external_fun' : (_this, p0) => _this.ensureDm(p0),
    'org.mlm.mages.matrix.eventAtTimestamp_$external_fun' : (_this, p0, p1, p2) => _this.eventAtTimestamp(p0, p1, p2),
    'org.mlm.mages.matrix.eventDetails_$external_fun' : (_this, p0, p1) => _this.eventDetails(p0, p1),
    'org.mlm.mages.matrix.fetchNotificationsSince_$external_fun' : (_this, p0, p1, p2) => _this.fetchNotificationsSince(p0, p1, p2),
    'org.mlm.mages.matrix.finishLoginFromRedirect_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.finishLoginFromRedirect(p0, p1, isDefault0 ? undefined : p2, ),
    'org.mlm.mages.matrix.forwardEvent_$external_fun' : (_this, p0, p1, p2) => _this.forwardEvent(p0, p1, p2),
    'org.mlm.mages.matrix.getDefaultRoomNotificationMode_$external_fun' : (_this, p0, p1) => _this.getDefaultRoomNotificationMode(p0, p1),
    'org.mlm.mages.matrix.getLinkPreview_$external_fun' : (_this, p0) => _this.getLinkPreview(p0),
    'org.mlm.mages.matrix.getMediaContent_$external_fun' : (_this, p0, p1) => _this.getMediaContent(p0, p1),
    'org.mlm.mages.matrix.getNotificationKeywords_$external_fun' : (_this, ) => _this.getNotificationKeywords(),
    'org.mlm.mages.matrix.getPinnedEvents_$external_fun' : (_this, p0) => _this.getPinnedEvents(p0),
    'org.mlm.mages.matrix.getPresence_$external_fun' : (_this, p0) => _this.getPresence(p0),
    'org.mlm.mages.matrix.getUserPowerLevel_$external_fun' : (_this, p0, p1) => _this.getUserPowerLevel(p0, p1),
    'org.mlm.mages.matrix.getUserProfile_$external_fun' : (_this, p0) => _this.getUserProfile(p0),
    'org.mlm.mages.matrix.homeserverLoginDetails_$external_fun' : (_this, ) => _this.homeserverLoginDetails(),
    'org.mlm.mages.matrix.ignoreUser_$external_fun' : (_this, p0) => _this.ignoreUser(p0),
    'org.mlm.mages.matrix.ignoredUsers_$external_fun' : (_this, ) => _this.ignoredUsers(),
    'org.mlm.mages.matrix.inviteBlocked_$external_fun' : (_this, ) => _this.inviteBlocked(),
    'org.mlm.mages.matrix.inviteUser_$external_fun' : (_this, p0, p1) => _this.inviteUser(p0, p1),
    'org.mlm.mages.matrix.isEventReadBy_$external_fun' : (_this, p0, p1, p2) => _this.isEventReadBy(p0, p1, p2),
    'org.mlm.mages.matrix.isLoggedIn_$external_fun' : (_this, ) => _this.isLoggedIn(),
    'org.mlm.mages.matrix.isPushRuleEnabled_$external_fun' : (_this, p0, p1) => _this.isPushRuleEnabled(p0, p1),
    'org.mlm.mages.matrix.isReactionNotificationsEnabled_$external_fun' : (_this, ) => _this.isReactionNotificationsEnabled(),
    'org.mlm.mages.matrix.isUserVerified_$external_fun' : (_this, p0) => _this.isUserVerified(p0),
    'org.mlm.mages.matrix.joinByIdOrAlias_$external_fun' : (_this, p0, p1, isDefault0) => _this.joinByIdOrAlias(p0, isDefault0 ? undefined : p1, ),
    'org.mlm.mages.matrix.kickUser_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.kickUser(p0, p1, isDefault0 ? undefined : p2, ),
    'org.mlm.mages.matrix.knock_$external_fun' : (_this, p0, p1) => _this.knock(p0, p1),
    'org.mlm.mages.matrix.leaveRoom_$external_fun' : (_this, p0) => _this.leaveRoom(p0),
    'org.mlm.mages.matrix.listAllImagePacks_$external_fun' : (_this, p0) => _this.listAllImagePacks(p0),
    'org.mlm.mages.matrix.listBannedMembers_$external_fun' : (_this, p0) => _this.listBannedMembers(p0),
    'org.mlm.mages.matrix.listImagePacks_$external_fun' : (_this, p0) => _this.listImagePacks(p0),
    'org.mlm.mages.matrix.listMembers_$external_fun' : (_this, p0) => _this.listMembers(p0),
    'org.mlm.mages.matrix.listMyDevices_$external_fun' : (_this, ) => _this.listMyDevices(),
    'org.mlm.mages.matrix.listSections_$external_fun' : (_this, ) => _this.listSections(),
    'org.mlm.mages.matrix.loadRoomListCache_$external_fun' : (_this, ) => _this.loadRoomListCache(),
    'org.mlm.mages.matrix.loginAsync_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.loginAsync(p0, p1, isDefault0 ? undefined : p2, ),
    'org.mlm.mages.matrix.loginEmail_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.loginEmail(p0, p1, isDefault0 ? undefined : p2, ),
    'org.mlm.mages.matrix.loginOauthBrowser_$external_fun' : (_this, p0, p1, isDefault0) => _this.loginOauthBrowser(p0, isDefault0 ? undefined : p1, ),
    'org.mlm.mages.matrix.loginPhone_$external_fun' : (_this, p0, p1, p2, p3, isDefault0) => _this.loginPhone(p0, p1, p2, isDefault0 ? undefined : p3, ),
    'org.mlm.mages.matrix.logout_$external_fun' : (_this, ) => _this.logout(),
    'org.mlm.mages.matrix.markFullyReadAt_$external_fun' : (_this, p0, p1, p2) => _this.markFullyReadAt(p0, p1, p2),
    'org.mlm.mages.matrix.markRead_$external_fun' : (_this, p0, p1) => _this.markRead(p0, p1),
    'org.mlm.mages.matrix.markRoomSeenLatest_$external_fun' : (_this, p0, p1) => _this.markRoomSeenLatest(p0, p1),
    'org.mlm.mages.matrix.markThreadReadAt_$external_fun' : (_this, p0, p1, p2, p3) => _this.markThreadReadAt(p0, p1, p2, p3),
    'org.mlm.mages.matrix.mediaCacheOverview_$external_fun' : (_this, ) => _this.mediaCacheOverview(),
    'org.mlm.mages.matrix.mediaItems_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.mediaItems(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.mlm.mages.matrix.mediaPreviewConfig_$external_fun' : (_this, ) => _this.mediaPreviewConfig(),
    'org.mlm.mages.matrix.mediaRetentionPolicy_$external_fun' : (_this, ) => _this.mediaRetentionPolicy(),
    'org.mlm.mages.matrix.mediaTypeMetrics_$external_fun' : (_this, ) => _this.mediaTypeMetrics(),
    'org.mlm.mages.matrix.memberActionState_$external_fun' : (_this, p0, p1) => _this.memberActionState(p0, p1),
    'org.mlm.mages.matrix.messageActionState_$external_fun' : (_this, p0, p1, p2) => _this.messageActionState(p0, p1, p2),
    'org.mlm.mages.matrix.moveSection_$external_fun' : (_this, p0, p1) => _this.moveSection(p0, p1),
    'org.mlm.mages.matrix.mutualRooms_$external_fun' : (_this, p0) => _this.mutualRooms(p0),
    'org.mlm.mages.matrix.mxcThumbnailToCache_$external_fun' : (_this, p0, p1, p2, p3) => _this.mxcThumbnailToCache(p0, p1, p2, p3),
    'org.mlm.mages.matrix.mySpaces_$external_fun' : (_this, ) => _this.mySpaces(),
    'org.mlm.mages.matrix.observeBackupState_$external_fun' : (_this, p0) => _this.observeBackupState(p0),
    'org.mlm.mages.matrix.observeCallDecline_$external_fun' : (_this, p0, p1, p2) => _this.observeCallDecline(p0, p1, p2),
    'org.mlm.mages.matrix.observeLiveLocation_$external_fun' : (_this, p0, p1) => _this.observeLiveLocation(p0, p1),
    'org.mlm.mages.matrix.observeOwnReceipt_$external_fun' : (_this, p0, p1) => _this.observeOwnReceipt(p0, p1),
    'org.mlm.mages.matrix.observeReceipts_$external_fun' : (_this, p0, p1) => _this.observeReceipts(p0, p1),
    'org.mlm.mages.matrix.observeRecoveryState_$external_fun' : (_this, p0) => _this.observeRecoveryState(p0),
    'org.mlm.mages.matrix.observeRoomCallState_$external_fun' : (_this, p0, p1) => _this.observeRoomCallState(p0, p1),
    'org.mlm.mages.matrix.observeRoomInfo_$external_fun' : (_this, p0, p1) => _this.observeRoomInfo(p0, p1),
    'org.mlm.mages.matrix.observeRoomList_$external_fun' : (_this, p0, p1) => _this.observeRoomList(p0, p1),
    'org.mlm.mages.matrix.observeSends_$external_fun' : (_this, p0) => _this.observeSends(p0),
    'org.mlm.mages.matrix.observeTimeline_$external_fun' : (_this, p0, p1, p2) => _this.observeTimeline(p0, p1, p2),
    'org.mlm.mages.matrix.observeTyping_$external_fun' : (_this, p0, p1) => _this.observeTyping(p0, p1),
    'org.mlm.mages.matrix.ownLastRead_$external_fun' : (_this, p0) => _this.ownLastRead(p0),
    'org.mlm.mages.matrix.ownProfileFields_$external_fun' : (_this, ) => _this.ownProfileFields(),
    'org.mlm.mages.matrix.ownProfile_$external_fun' : (_this, ) => _this.ownProfile(),
    'org.mlm.mages.matrix.paginateBackwards_$external_fun' : (_this, p0, p1) => _this.paginateBackwards(p0, p1),
    'org.mlm.mages.matrix.publicRooms_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.publicRooms(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
    'org.mlm.mages.matrix.react_$external_fun' : (_this, p0, p1, p2, p3, isDefault0) => _this.react(p0, p1, p2, isDefault0 ? undefined : p3, ),
    'org.mlm.mages.matrix.reactionsForEvent_$external_fun' : (_this, p0, p1) => _this.reactionsForEvent(p0, p1),
    'org.mlm.mages.matrix.recentEmoji_$external_fun' : (_this, ) => _this.recentEmoji(),
    'org.mlm.mages.matrix.recentEvents_$external_fun' : (_this, p0, p1) => _this.recentEvents(p0, p1),
    'org.mlm.mages.matrix.recordEmojiUse_$external_fun' : (_this, p0) => _this.recordEmojiUse(p0),
    'org.mlm.mages.matrix.recoverWithKey_$external_fun' : (_this, p0) => _this.recoverWithKey(p0),
    'org.mlm.mages.matrix.redact_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.redact(p0, p1, isDefault0 ? undefined : p2, ),
    'org.mlm.mages.matrix.removeAvatar_$external_fun' : (_this, ) => _this.removeAvatar(),
    'org.mlm.mages.matrix.removeImagePack_$external_fun' : (_this, p0, p1) => _this.removeImagePack(p0, p1),
    'org.mlm.mages.matrix.removeNotificationKeyword_$external_fun' : (_this, p0) => _this.removeNotificationKeyword(p0),
    'org.mlm.mages.matrix.removeRoomAvatar_$external_fun' : (_this, p0) => _this.removeRoomAvatar(p0),
    'org.mlm.mages.matrix.renameSection_$external_fun' : (_this, p0, p1) => _this.renameSection(p0, p1),
    'org.mlm.mages.matrix.reply_$external_fun' : (_this, p0, p1, p2, p3, isDefault0) => _this.reply(p0, p1, p2, isDefault0 ? undefined : p3, ),
    'org.mlm.mages.matrix.reportContent_$external_fun' : (_this, p0, p1, p2, p3, isDefault0, isDefault1) => _this.reportContent(p0, p1, isDefault0 ? undefined : p2, isDefault1 ? undefined : p3, ),
    'org.mlm.mages.matrix.reportRoom_$external_fun' : (_this, p0, p1, isDefault0) => _this.reportRoom(p0, isDefault0 ? undefined : p1, ),
    'org.mlm.mages.matrix.resetRecoveryKey_$external_fun' : (_this, ) => _this.resetRecoveryKey(),
    'org.mlm.mages.matrix.resolveRoomId_$external_fun' : (_this, p0) => _this.resolveRoomId(p0),
    'org.mlm.mages.matrix.roomActionState_$external_fun' : (_this, p0) => _this.roomActionState(p0),
    'org.mlm.mages.matrix.roomDirectoryVisibility_$external_fun' : (_this, p0) => _this.roomDirectoryVisibility(p0),
    'org.mlm.mages.matrix.roomHistoryVisibility_$external_fun' : (_this, p0) => _this.roomHistoryVisibility(p0),
    'org.mlm.mages.matrix.roomInfoSnapshot_$external_fun' : (_this, p0) => _this.roomInfoSnapshot(p0),
    'org.mlm.mages.matrix.roomInviter_$external_fun' : (_this, p0) => _this.roomInviter(p0),
    'org.mlm.mages.matrix.roomJoinRuleAllowList_$external_fun' : (_this, p0) => _this.roomJoinRuleAllowList(p0),
    'org.mlm.mages.matrix.roomJoinRule_$external_fun' : (_this, p0) => _this.roomJoinRule(p0),
    'org.mlm.mages.matrix.roomListSetUnreadOnly_$external_fun' : (_this, p0, p1) => _this.roomListSetUnreadOnly(p0, p1),
    'org.mlm.mages.matrix.roomListUpdateVisibleRange_$external_fun' : (_this, p0, p1, p2) => _this.roomListUpdateVisibleRange(p0, p1, p2),
    'org.mlm.mages.matrix.roomNotificationMode_$external_fun' : (_this, p0) => _this.roomNotificationMode(p0),
    'org.mlm.mages.matrix.roomParentSpaces_$external_fun' : (_this, p0) => _this.roomParentSpaces(p0),
    'org.mlm.mages.matrix.roomPowerLevels_$external_fun' : (_this, p0) => _this.roomPowerLevels(p0),
    'org.mlm.mages.matrix.roomPredecessor_$external_fun' : (_this, p0) => _this.roomPredecessor(p0),
    'org.mlm.mages.matrix.roomPreview_$external_fun' : (_this, p0, p1) => _this.roomPreview(p0, p1),
    'org.mlm.mages.matrix.roomProfile_$external_fun' : (_this, p0) => _this.roomProfile(p0),
    'org.mlm.mages.matrix.roomStorageUsage_$external_fun' : (_this, p0) => _this.roomStorageUsage(p0),
    'org.mlm.mages.matrix.roomSuccessor_$external_fun' : (_this, p0) => _this.roomSuccessor(p0),
    'org.mlm.mages.matrix.roomTags_$external_fun' : (_this, p0) => _this.roomTags(p0),
    'org.mlm.mages.matrix.roomUnreadStats_$external_fun' : (_this, p0) => _this.roomUnreadStats(p0),
    'org.mlm.mages.matrix.rooms_$external_fun' : (_this, ) => _this.rooms(),
    'org.mlm.mages.matrix.saveImagePack_$external_fun' : (_this, p0, p1) => _this.saveImagePack(p0, p1),
    'org.mlm.mages.matrix.searchRoom_$external_fun' : (_this, p0, p1, p2, p3, isDefault0) => _this.searchRoom(p0, p1, p2, isDefault0 ? undefined : p3, ),
    'org.mlm.mages.matrix.searchUsers_$external_fun' : (_this, p0, p1) => _this.searchUsers(p0, p1),
    'org.mlm.mages.matrix.seenByForEvent_$external_fun' : (_this, p0, p1, p2) => _this.seenByForEvent(p0, p1, p2),
    'org.mlm.mages.matrix.sendAttachmentBytes_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, isDefault0, isDefault1, isDefault2, isDefault3, isDefault4, isDefault5) => _this.sendAttachmentBytes(p0, p1, p2, p3, isDefault0 ? undefined : p4, isDefault1 ? undefined : p5, isDefault2 ? undefined : p6, isDefault3 ? undefined : p7, isDefault4 ? undefined : p8, isDefault5 ? undefined : p9, ),
    'org.mlm.mages.matrix.sendLiveLocation_$external_fun' : (_this, p0, p1) => _this.sendLiveLocation(p0, p1),
    'org.mlm.mages.matrix.sendMessage_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.sendMessage(p0, p1, isDefault0 ? undefined : p2, ),
    'org.mlm.mages.matrix.sendPollEnd_$external_fun' : (_this, p0, p1) => _this.sendPollEnd(p0, p1),
    'org.mlm.mages.matrix.sendPollResponse_$external_fun' : (_this, p0, p1, p2) => _this.sendPollResponse(p0, p1, p2),
    'org.mlm.mages.matrix.sendPollStart_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.sendPollStart(p0, p1, p2, p3, p4),
    'org.mlm.mages.matrix.sendQueueSetEnabled_$external_fun' : (_this, p0) => _this.sendQueueSetEnabled(p0),
    'org.mlm.mages.matrix.sendStaticLocation_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.sendStaticLocation(p0, p1, isDefault0 ? undefined : p2, ),
    'org.mlm.mages.matrix.sendStickerMxc_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.sendStickerMxc(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
    'org.mlm.mages.matrix.sendThreadText_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, isDefault0, isDefault1, isDefault2) => _this.sendThreadText(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, isDefault2 ? undefined : p5, ),
    'org.mlm.mages.matrix.setAccountData_$external_fun' : (_this, p0, p1) => _this.setAccountData(p0, p1),
    'org.mlm.mages.matrix.setAutoDownloadNetwork_$external_fun' : (_this, p0, p1) => _this.setAutoDownloadNetwork(p0, p1),
    'org.mlm.mages.matrix.setAutoDownloadRules_$external_fun' : (_this, p0) => _this.setAutoDownloadRules(p0),
    'org.mlm.mages.matrix.setAvatarBytes_$external_fun' : (_this, p0, p1) => _this.setAvatarBytes(p0, p1),
    'org.mlm.mages.matrix.setDefaultRoomNotificationMode_$external_fun' : (_this, p0, p1, p2) => _this.setDefaultRoomNotificationMode(p0, p1, p2),
    'org.mlm.mages.matrix.setDisplayName_$external_fun' : (_this, p0, isDefault0) => _this.setDisplayName(isDefault0 ? undefined : p0, ),
    'org.mlm.mages.matrix.setEventNotificationsEnabled_$external_fun' : (_this, p0, p1, p2) => _this.setEventNotificationsEnabled(p0, p1, p2),
    'org.mlm.mages.matrix.setImagePackEnabled_$external_fun' : (_this, p0, p1, p2) => _this.setImagePackEnabled(p0, p1, p2),
    'org.mlm.mages.matrix.setInviteBlocked_$external_fun' : (_this, p0) => _this.setInviteBlocked(p0),
    'org.mlm.mages.matrix.setKeyBackupEnabled_$external_fun' : (_this, p0) => _this.setKeyBackupEnabled(p0),
    'org.mlm.mages.matrix.setMarkUnread_$external_fun' : (_this, p0, p1) => _this.setMarkUnread(p0, p1),
    'org.mlm.mages.matrix.setMediaPreviewConfig_$external_fun' : (_this, p0) => _this.setMediaPreviewConfig(p0),
    'org.mlm.mages.matrix.setMediaRetentionPolicy_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.setMediaRetentionPolicy(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.mlm.mages.matrix.setPinnedEvents_$external_fun' : (_this, p0, p1) => _this.setPinnedEvents(p0, p1),
    'org.mlm.mages.matrix.setPresence_$external_fun' : (_this, p0, p1, isDefault0) => _this.setPresence(p0, isDefault0 ? undefined : p1, ),
    'org.mlm.mages.matrix.setProfileField_$external_fun' : (_this, p0, p1) => _this.setProfileField(p0, p1),
    'org.mlm.mages.matrix.setPushRuleEnabled_$external_fun' : (_this, p0, p1, p2) => _this.setPushRuleEnabled(p0, p1, p2),
    'org.mlm.mages.matrix.setReactionNotificationsEnabled_$external_fun' : (_this, p0) => _this.setReactionNotificationsEnabled(p0),
    'org.mlm.mages.matrix.setRoomAvatarBytes_$external_fun' : (_this, p0, p1, p2) => _this.setRoomAvatarBytes(p0, p1, p2),
    'org.mlm.mages.matrix.setRoomCanonicalAlias_$external_fun' : (_this, p0, p1, p2) => _this.setRoomCanonicalAlias(p0, p1, p2),
    'org.mlm.mages.matrix.setRoomDirectoryVisibility_$external_fun' : (_this, p0, p1) => _this.setRoomDirectoryVisibility(p0, p1),
    'org.mlm.mages.matrix.setRoomFavourite_$external_fun' : (_this, p0, p1) => _this.setRoomFavourite(p0, p1),
    'org.mlm.mages.matrix.setRoomHistoryVisibility_$external_fun' : (_this, p0, p1) => _this.setRoomHistoryVisibility(p0, p1),
    'org.mlm.mages.matrix.setRoomJoinRule_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setRoomJoinRule(p0, p1, isDefault0 ? undefined : p2, ),
    'org.mlm.mages.matrix.setRoomLowPriority_$external_fun' : (_this, p0, p1) => _this.setRoomLowPriority(p0, p1),
    'org.mlm.mages.matrix.setRoomName_$external_fun' : (_this, p0, p1) => _this.setRoomName(p0, p1),
    'org.mlm.mages.matrix.setRoomNotificationMode_$external_fun' : (_this, p0, p1) => _this.setRoomNotificationMode(p0, p1),
    'org.mlm.mages.matrix.setRoomSection_$external_fun' : (_this, p0, p1, isDefault0) => _this.setRoomSection(p0, isDefault0 ? undefined : p1, ),
    'org.mlm.mages.matrix.setRoomTopic_$external_fun' : (_this, p0, p1) => _this.setRoomTopic(p0, p1),
    'org.mlm.mages.matrix.setTyping_$external_fun' : (_this, p0, p1) => _this.setTyping(p0, p1),
    'org.mlm.mages.matrix.setupRecovery_$external_fun' : (_this, ) => _this.setupRecovery(),
    'org.mlm.mages.matrix.spaceAddChild_$external_fun' : (_this, p0, p1, p2, p3, isDefault0, isDefault1) => _this.spaceAddChild(p0, p1, isDefault0 ? undefined : p2, isDefault1 ? undefined : p3, ),
    'org.mlm.mages.matrix.spaceHierarchy_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.spaceHierarchy(p0, p1, p2, p3, p4),
    'org.mlm.mages.matrix.spaceInviteUser_$external_fun' : (_this, p0, p1) => _this.spaceInviteUser(p0, p1),
    'org.mlm.mages.matrix.spaceRemoveChild_$external_fun' : (_this, p0, p1) => _this.spaceRemoveChild(p0, p1),
    'org.mlm.mages.matrix.spaceUnreadCounts_$external_fun' : (_this, ) => _this.spaceUnreadCounts(),
    'org.mlm.mages.matrix.startDeviceVerification_$external_fun' : (_this, p0, p1) => _this.startDeviceVerification(p0, p1),
    'org.mlm.mages.matrix.startElementCall_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, p6) => _this.startElementCall(p0, p1, p2, p3, p4, p5, p6),
    'org.mlm.mages.matrix.startLiveLocation_$external_fun' : (_this, p0, p1) => _this.startLiveLocation(p0, p1),
    'org.mlm.mages.matrix.startSupervisedSync_$external_fun' : (_this, p0) => _this.startSupervisedSync(p0),
    'org.mlm.mages.matrix.startUserVerification_$external_fun' : (_this, p0, p1) => _this.startUserVerification(p0, p1),
    'org.mlm.mages.matrix.startVerificationInbox_$external_fun' : (_this, p0, p1) => _this.startVerificationInbox(p0, p1),
    'org.mlm.mages.matrix.stopElementCall_$external_fun' : (_this, p0) => _this.stopElementCall(p0),
    'org.mlm.mages.matrix.stopLiveLocation_$external_fun' : (_this, p0) => _this.stopLiveLocation(p0),
    'org.mlm.mages.matrix.subscribeRooms_$external_fun' : (_this, p0) => _this.subscribeRooms(p0),
    'org.mlm.mages.matrix.suggestImageShortcodes_$external_fun' : (_this, p0, p1) => _this.suggestImageShortcodes(p0, p1),
    'org.mlm.mages.matrix.threadReplies_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.threadReplies(p0, p1, p2, p3, p4),
    'org.mlm.mages.matrix.threadSummary_$external_fun' : (_this, p0, p1, p2, p3) => _this.threadSummary(p0, p1, p2, p3),
    'org.mlm.mages.matrix.thumbnailToCache_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.thumbnailToCache(p0, p1, p2, p3, p4),
    'org.mlm.mages.matrix.unbanUser_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.unbanUser(p0, p1, isDefault0 ? undefined : p2, ),
    'org.mlm.mages.matrix.unignoreUser_$external_fun' : (_this, p0) => _this.unignoreUser(p0),
    'org.mlm.mages.matrix.unobserveBackupState_$external_fun' : (_this, p0) => _this.unobserveBackupState(p0),
    'org.mlm.mages.matrix.unobserveCallDecline_$external_fun' : (_this, p0) => _this.unobserveCallDecline(p0),
    'org.mlm.mages.matrix.unobserveLiveLocation_$external_fun' : (_this, p0) => _this.unobserveLiveLocation(p0),
    'org.mlm.mages.matrix.unobserveReceipts_$external_fun' : (_this, p0) => _this.unobserveReceipts(p0),
    'org.mlm.mages.matrix.unobserveRecoveryState_$external_fun' : (_this, p0) => _this.unobserveRecoveryState(p0),
    'org.mlm.mages.matrix.unobserveRoomCallState_$external_fun' : (_this, p0) => _this.unobserveRoomCallState(p0),
    'org.mlm.mages.matrix.unobserveRoomInfo_$external_fun' : (_this, p0) => _this.unobserveRoomInfo(p0),
    'org.mlm.mages.matrix.unobserveRoomList_$external_fun' : (_this, p0) => _this.unobserveRoomList(p0),
    'org.mlm.mages.matrix.unobserveSends_$external_fun' : (_this, p0) => _this.unobserveSends(p0),
    'org.mlm.mages.matrix.unobserveTimeline_$external_fun' : (_this, p0) => _this.unobserveTimeline(p0),
    'org.mlm.mages.matrix.unobserveTyping_$external_fun' : (_this, p0) => _this.unobserveTyping(p0),
    'org.mlm.mages.matrix.unobserveVerificationInbox_$external_fun' : (_this, p0) => _this.unobserveVerificationInbox(p0),
    'org.mlm.mages.matrix.updatePowerLevelForUser_$external_fun' : (_this, p0, p1, p2) => _this.updatePowerLevelForUser(p0, p1, p2),
    'org.mlm.mages.matrix.uploadBytes_$external_fun' : (_this, p0, p1) => _this.uploadBytes(p0, p1),
    'org.mlm.mages.matrix.uploadPackImageBytes_$external_fun' : (_this, p0, p1) => _this.uploadPackImageBytes(p0, p1),
    'org.mlm.mages.matrix.userDefinedRoomNotificationMode_$external_fun' : (_this, p0) => _this.userDefinedRoomNotificationMode(p0),
    'org.mlm.mages.matrix.whoami_$external_fun' : (_this, ) => _this.whoami(),
    'org.mlm.mages.matrix.WasmClient_$external_class_instanceof' : (x) => x instanceof _ref_Li93YXNtL21hZ2VzX2ZmaS5qcw_.WasmClient,
    'org.mlm.mages.matrix.WasmClient_$external_class_get' : () => _ref_Li93YXNtL21hZ2VzX2ZmaS5qcw_.WasmClient,
    'org.mlm.mages.matrix.jsCallback1' : (fn) => function(a) { return fn(a); },
    'org.mlm.mages.matrix.retryByTxnInterop' : (client, roomId, txnId) => {
      if (!client) return Promise.resolve(false);
      const fn = client.retryByTxn || client.retry_by_txn;
      if (typeof fn !== 'function') return Promise.resolve(false);
      try {
        return Promise.resolve(fn.call(client, roomId, txnId));
      } catch (_) {
        return Promise.resolve(false);
      }
    },
    'org.mlm.mages.matrix.cancelByTxnInterop' : (client, roomId, txnId) => {
      if (!client) return Promise.resolve(false);
      const fn = client.cancelByTxn || client.cancel_by_txn;
      if (typeof fn !== 'function') return Promise.resolve(false);
      try {
        return Promise.resolve(fn.call(client, roomId, txnId));
      } catch (_) {
        return Promise.resolve(false);
      }
    },
    'org.mlm.mages.matrix.voiceDurationMsToJs' : (ms) => ms == null ? undefined : BigInt(Math.trunc(ms)),
    'org.mlm.mages.matrix.jsCallback0' : (fn) => function() { fn(); },
    'org.mlm.mages.matrix.openOAuthPopup' : (url, redirectOrigin) => new Promise((resolve) => {
        const w = window.open(url, '_blank', 'width=600,height=700,popup=yes');
        if (!w) { resolve(null); return; }

        const timer = setInterval(() => {
            try {
                if (w.location.origin === redirectOrigin) {
                    const href = w.location.href;
                    clearInterval(timer);
                    w.close();
                    resolve(href);
                }
            } catch (e) {

            }
        }, 200);

        const closeTimer = setInterval(() => {
            if (w.closed) {
                clearInterval(timer);
                clearInterval(closeTimer);
                resolve(null);
            }
        }, 500);
    }),
    'org.mlm.mages.matrix.jsWidgetObserver' : (fn) => function(msg) { fn(msg); },
    'org.mlm.mages.matrix.base64ToUint8Array' : (base64) => {
        const bin = atob(base64);
        const bytes = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        return bytes;
    },
    'org.mlm.mages.matrix.stringify_$external_fun' : (_this, p0) => _this.stringify(p0),
    'org.mlm.mages.matrix.JsJson_$external_object_getInstance' : () => JSON,
    'org.mlm.mages.platform.updateCustomLocale' : (value) => { if (window.__customLocale !== value) { window.__customLocale = value; window.dispatchEvent(new Event("languagechange")); } },
    'org.mlm.mages.platform.sendToElementCallIframe' : (message) => {
        var ec = globalThis._ec; if (!ec) return false;
        var payload;
        try { payload = JSON.parse(message); } catch(_) { payload = message; }
        if (ec.iframe && ec.iframe.contentWindow) {
            try { ec.iframe.contentWindow.postMessage(payload, '*'); return true; } catch(_) {}
        }
        try { if (window.parent && window.parent !== window) { window.parent.postMessage(payload, '*'); return true; } } catch(_) {}
        return false;
    },
    'org.mlm.mages.platform.sendElementActionResponse' : (originalMessage) => {
        var ec = globalThis._ec; if (!ec) return false;
        try {
            var msg = JSON.parse(originalMessage);
            var response = { api: 'toWidget', widgetId: msg.widgetId || '', requestId: msg.requestId || '', action: msg.action || '', response: {} };
            if (ec.iframe && ec.iframe.contentWindow) { ec.iframe.contentWindow.postMessage(response, '*'); return true; }
        } catch(_) {}
        return false;
    },
    'org.mlm.mages.platform.removeElementCallIframe' : () => {
        var ec = globalThis._ec; if (!ec) return;
        if (ec.listener) { window.removeEventListener('message', ec.listener); ec.listener = null; }
        if (ec.iframe) { if (ec.iframe.parentNode) ec.iframe.parentNode.removeChild(ec.iframe); ec.iframe = null; }
        if (ec.container) { if (ec.container.parentNode) ec.container.parentNode.removeChild(ec.container); ec.container = null; }
        ec.onMsg = null;
    },
    'org.mlm.mages.platform.setElementCallMinimized' : (minimized) => {
        var ec = globalThis._ec; if (ec && ec.applyState) ec.applyState(minimized);
    },
    'org.mlm.mages.platform.ensureEcState' : () => {
        if (!globalThis._ec) globalThis._ec = {
            iframe: null, listener: null, onMsg: null, container: null,
            isWidget: function(d) {
                return !!d && typeof d === 'object' && (
                    (d.response && d.api === 'toWidget') ||
                    (!d.response && d.api === 'fromWidget')
                );
            },
            applyState: function(min) {
                var c = globalThis._ec.container;
                if (!c) return;
                if (min) {
                    c.style.cssText = 'position:fixed;width:220px;height:140px;top:120px;left:24px;z-index:999999;border-radius:16px;overflow:hidden;box-shadow:0 8px 24px rgba(0,0,0,0.35);background:#000';
                } else {
                    c.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;width:100vw;height:100vh;z-index:999999;border-radius:0;overflow:visible;box-shadow:none;background:#000';
                }
            }
        };
    },
    'org.mlm.mages.platform.createElementCallIframeInternal' : (containerId, widgetUrl, onMessage) => {
        var ec = globalThis._ec;
        if (ec.iframe) {
            if (ec.listener) { window.removeEventListener('message', ec.listener); ec.listener = null; }
            if (ec.iframe.parentNode) ec.iframe.parentNode.removeChild(ec.iframe);
            if (ec.container && ec.container.parentNode) ec.container.parentNode.removeChild(ec.container);
            ec.iframe = null; ec.container = null; ec.onMsg = null;
        }
        ec.onMsg = onMessage;
        var container = document.getElementById(containerId);
        if (!container) {
            container = document.createElement('div');
            container.id = containerId;
            document.body.appendChild(container);
        }
        ec.container = container;
        ec.applyState(false);
        container.innerHTML = '';
        var iframe = document.createElement('iframe');
        iframe.src = widgetUrl;
        iframe.style.cssText = 'width:100%;height:100%;border:none;position:absolute;top:0;left:0';
        iframe.allow = 'camera; microphone; display-capture; fullscreen; geolocation';
        iframe.setAttribute('allow', 'camera; microphone; display-capture; fullscreen; geolocation');
        container.appendChild(iframe);
        ec.iframe = iframe;
        ec.listener = function(event) {
            if (ec.onMsg && ec.isWidget(event.data)) {
                try { ec.onMsg(typeof event.data === 'string' ? event.data : JSON.stringify(event.data)); } catch(_) {}
            }
        };
        window.addEventListener('message', ec.listener);
        return true;
    },
    'org.mlm.mages.platform.revokeBlobUrl' : (url) => {
      try { URL.revokeObjectURL(url); } catch (_) {}
    },
    'org.mlm.mages.platform.isAudioBase64DataUrl' : (v) => {
      if (typeof v !== 'string') return false;
      return /^data:audio\/[^;]+(?:;[^,]*)?;base64,/i.test(v);
    },
    'org.mlm.mages.platform.isOggBase64DataUrl' : (v) => {
      if (typeof v !== 'string') return false;
      return /^data:audio\/ogg(?:;[^,]*)?;base64,/i.test(v);
    },
    'org.mlm.mages.platform.browserSupportsOggPlayback' : () => {
      const a = document.createElement('audio');
      const canPlay = (t) => {
        try {
          const r = a.canPlayType(t);
          return r === 'probably' || r === 'maybe';
        } catch (_) {
          return false;
        }
      };
      return canPlay('audio/ogg; codecs="opus"') || canPlay('audio/ogg;codecs=opus') || canPlay('audio/ogg');
    },
    'org.mlm.mages.platform.createAudioBlobUrl' : (base64, mime) => {
      try {
        const bin = atob(base64);
        const bytes = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        const blob = new Blob([bytes], { type: mime || 'application/octet-stream' });
        return URL.createObjectURL(blob);
      } catch (_) {
        return null;
      }
    },
    'org.mlm.mages.platform.navigatorOnLine' : () => typeof navigator !== 'undefined' ? navigator.onLine === true : true,
    'org.mlm.mages.platform.documentVisibilityState' : () => document.visibilityState,
    'org.mlm.mages.platform.windowIsSecureContextJs' : () => window.isSecureContext === true,
    'org.mlm.mages.platform.notificationSupportedJs' : () => typeof window !== 'undefined' && typeof Notification !== 'undefined',
    'org.mlm.mages.platform.notificationPermissionJs' : () => (typeof window !== 'undefined' && typeof Notification !== 'undefined') ? Notification.permission : 'denied',
    'org.mlm.mages.platform.createBrowserNotificationJs' : (title, body, icon, tag, image) => {
            if (typeof window === 'undefined' || typeof Notification === 'undefined') return false;
            if (Notification.permission !== 'granted') return false;

            try {
                const opts = {
                    body: body === null ? undefined : body,
                    icon: icon === null ? undefined : icon,
                    image: image === null || image === undefined ? undefined : image,
                    silent: true,
                };
                if (tag !== null && tag !== undefined) opts.tag = tag;
                const n = new Notification(title, opts);
                n.onerror = (event) => console.error("Notification error", event);
                n.onclick = (event) => {
                    try {
                        event.preventDefault();
                        if (window.focus) window.focus();
                    } catch (e) {}
                };
                try {
                    if (tag !== null && tag !== undefined) {
                        window.__magesNotifs = window.__magesNotifs || {};
                        const prev = window.__magesNotifs[tag];
                        try { if (prev && prev !== n) prev.close(); } catch (e) {}
                        window.__magesNotifs[tag] = n;
                        n.onclose = () => {
                            try {
                                if (window.__magesNotifs && window.__magesNotifs[tag] === n) {
                                    delete window.__magesNotifs[tag];
                                }
                            } catch (e) {}
                        };
                    }
                } catch (e) {}
                return true;
            } catch (e) {
                console.error("Notification constructor failed", e);
                return false;
            }
        },
    'org.mlm.mages.platform.closeBrowserNotificationByTagJs' : (tag) => {
            try {
                const m = window.__magesNotifs;
                if (!m || tag === null || tag === undefined) return false;
                const n = m[tag];
                if (n) {
                    try { n.close(); } catch (e) {}
                    delete m[tag];
                    return true;
                }
            } catch (e) {}
            return false;
        },
    'org.mlm.mages.platform.requestNotificationPermissionJs' : (callback) => {
            if (typeof window === 'undefined' || typeof Notification === 'undefined') {
                callback("denied");
                return;
            }

            try {
                const result = Notification.requestPermission();
                if (result && typeof result.then === "function") {
                    result.then(
                        (permission) => callback(String(permission)),
                        () => callback("denied"),
                    );
                } else {
                    callback(String(Notification.permission || "denied"));
                }
            } catch (e) {
                console.error("Notification.requestPermission failed", e);
                callback("denied");
            }
        },
    'org.mlm.mages.platform.inputSelectedFile' : (input) => input.files ? input.files.item(0) : null,
    'org.mlm.mages.platform.navigatorShareSupported' : () => typeof navigator !== 'undefined' && typeof navigator.share === 'function',
    'org.mlm.mages.platform.shareDataCreate' : () => ({}),
    'org.mlm.mages.platform.shareDataSetTitle' : (data, title) => { data.title = title; },
    'org.mlm.mages.platform.shareDataSetText' : (data, text) => { data.text = text; },
    'org.mlm.mages.platform.shareDataSetUrl' : (data, url) => { data.url = url; },
    'org.mlm.mages.platform.navigatorCanShareSupported' : () => typeof navigator !== 'undefined' && typeof navigator.canShare === 'function',
    'org.mlm.mages.platform.navigatorCanShare' : (data) => navigator.canShare(data),
    'org.mlm.mages.platform.navigatorShare' : (data) => navigator.share(data),
    'org.mlm.mages.platform.navigatorClipboardWriteTextSupported' : () => typeof navigator !== 'undefined' && !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function',
    'org.mlm.mages.platform.navigatorClipboardWriteText' : (text) => navigator.clipboard.writeText(text),
    'org.mlm.mages.platform.textareaSelect' : (textarea) => textarea.select(),
    'org.mlm.mages.platform.documentExecCopy' : () => document.execCommand('copy'),
    'org.mlm.mages.platform.clipboardDataOf' : (event) => event.clipboardData ? event.clipboardData : null,
    'org.mlm.mages.platform.dataTransferOf' : (event) => event.dataTransfer ? event.dataTransfer : null,
    'org.mlm.mages.platform.dataTransferItemsOf' : (transfer) => transfer.items ? transfer.items : null,
    'org.mlm.mages.platform.arrayLikeLength' : (value) => value.length | 0,
    'org.mlm.mages.platform.arrayLikeItem' : (value, index) => (value[index] !== undefined) ? value[index] : null,
    'org.mlm.mages.platform.dataTransferItemKind' : (item) => item.kind ? item.kind : null,
    'org.mlm.mages.platform.dataTransferItemGetAsFile' : (item) => item.getAsFile ? item.getAsFile() : null,
    'org.mlm.mages.platform.dataTransferFilesOf' : (transfer) => transfer.files ? transfer.files : null,
    'org.mlm.mages.platform.fileListItem' : (files, index) => files.item ? files.item(index) : ((files[index] !== undefined) ? files[index] : null)
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    